"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("antd/dist/antd.css");
var _antd2 = require("antd");
require("./Input.scss");
require("./CustomInputFilter.css");
var _icons = require("@ant-design/icons");
var _HeaderText = require("@ccw-pwa-ui/HeaderText");
var _reactPhoneInput = _interopRequireDefault(require("react-phone-input-2"));
var _Dropdown = require("@ccw-pwa-ui/Dropdown");
require("react-phone-input-2/lib/style.css");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const CustomInput = _ref => {
  let {
    onPaste,
    onCopy,
    placeholder,
    onchange,
    inputType,
    value,
    disabled,
    disableDropdown,
    suffix,
    isErrorFree,
    inputStyle,
    inputTitle,
    notificationText,
    inputProps,
    selectProps,
    headerProps,
    errorProps,
    countryCodeEditable,
    country,
    Countries,
    isValidPhoneNumber,
    phoneNumberInputClass,
    numberInvalidText,
    onBlur,
    onKeyPress,
    dynamicTitleStyle,
    containerStyle,
    onlyCountries,
    maxLength
  } = _ref;
  let inputRender;
  switch (inputType) {
    case "password":
      inputRender = /*#__PURE__*/_react.default.createElement(_antd2.Input.Password, {
        style: inputStyle,
        disabled: disabled,
        placeholder: placeholder,
        onChange: onchange,
        onKeyPress: onKeyPress,
        onBlur: onBlur ? onBlur : () => {},
        iconRender: visible => visible ? /*#__PURE__*/_react.default.createElement(_icons.EyeTwoTone, null) : /*#__PURE__*/_react.default.createElement(_icons.EyeInvisibleOutlined, null)
      });
      break;
    case "confirm-password":
      let dynamicHeaderStyle = {
        fontSize: 16
      };
      if (isErrorFree === false) {
        dynamicHeaderStyle.color = '#FF2D55';
      }
      inputRender = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
        headerStyle: dynamicHeaderStyle,
        variant: "header-text",
        headerText: headerProps.headerText
      }), /*#__PURE__*/_react.default.createElement(_antd2.Input, {
        style: inputStyle,
        placeholder: placeholder,
        className: "cust-input-confirm-password",
        disabled: disabled,
        value: value,
        onBlur: onBlur ? onBlur : () => {},
        onChange: onchange,
        onKeyPress: onKeyPress,
        suffix: suffix
      }), isErrorFree === false && /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
        headerStyle: {
          fontSize: 12,
          color: '#FF2D55',
          marginBottom: 0
        },
        variant: "header-text",
        headerText: errorProps.headerText
      }));
      break;
    case "phone-input":
      if (isErrorFree === false) {
        dynamicTitleStyle.color = '#FF2D55';
      }
      inputRender = /*#__PURE__*/_react.default.createElement("div", {
        className: containerStyle
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }
      }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
        headerStyle: dynamicTitleStyle,
        variant: headerProps.variant,
        headerText: inputTitle
      })), /*#__PURE__*/_react.default.createElement(_reactPhoneInput.default, {
        disabled: disabled,
        placeholder: placeholder,
        disableDropdown: disableDropdown,
        countryCodeEditable: countryCodeEditable,
        country: country,
        preferredCountries: Countries,
        value: value,
        onlyCountries: onlyCountries,
        onChange: onchange,
        onBlur: onBlur ? onBlur : () => {},
        inputClass: phoneNumberInputClass
      }), isValidPhoneNumber ? /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
        headerStyle: {
          fontSize: 13,
          color: '#333333',
          marginBottom: 0,
          fontWeight: 400
        },
        variant: "header-text",
        headerText: notificationText
      }) : /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
        headerStyle: {
          fontSize: 13,
          color: 'red',
          marginBottom: 0,
          fontWeight: 400
        },
        variant: "header-text",
        headerText: numberInvalidText
      }));
      break;
    case "filter-search-box":
      inputRender = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
        className: "filter_input_box",
        style: inputStyle
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "custom_filter_box",
        style: selectProps.inputStyle
      }, /*#__PURE__*/_react.default.createElement(_Dropdown.Dropdown, {
        selectedItem: selectProps.selectedItem,
        dropdownList: selectProps.dropdownList,
        itemClick: selectProps.itemClick,
        title: selectProps.title
      })), /*#__PURE__*/_react.default.createElement("span", {
        className: "verticle_line_border"
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "custom_input_box",
        style: inputProps.inputStyle
      }, /*#__PURE__*/_react.default.createElement(_antd2.Input, {
        className: "no_border"
        // style={inputProps.inputStyle}
        ,
        disabled: inputProps.disabled,
        allowClear: true,
        value: inputProps.value,
        placeholder: inputProps.placeholder,
        onChange: inputProps.onchange,
        onBlur: onBlur,
        onKeyPress: onKeyPress,
        suffix: inputProps.suffix
      }))), /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
        headerStyle: {
          fontSize: 13,
          color: '#333333',
          marginBottom: 0,
          fontWeight: 400
        },
        variant: "header-text",
        headerText: notificationText
      }));
      break;
    case "lable-input-error":
      inputRender = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
        headerStyle: headerProps.headerStyle,
        variant: headerProps.variant,
        headerText: headerProps.headerText
      }), /*#__PURE__*/_react.default.createElement(_antd2.Input, {
        onPaste: onPaste,
        onCopy: onCopy,
        "data-testid": inputProps.testId || "",
        style: inputProps.inputStyle,
        disabled: inputProps.disabled,
        value: inputProps.value,
        placeholder: inputProps.placeholder,
        onChange: inputProps.onchange,
        onBlur: onBlur,
        onKeyPress: onKeyPress,
        suffix: inputProps.suffix,
        type: inputProps.type,
        allowClear: true
      }), /*#__PURE__*/_react.default.createElement("div", {
        style: {
          minHeight: "24px"
        }
      }, isErrorFree === false && /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
        headerStyle: errorProps.headerStyle,
        variant: errorProps.variant,
        headerText: errorProps.headerText
      })));
      break;
    default:
      inputRender = /*#__PURE__*/_react.default.createElement(_antd2.Input, {
        style: inputStyle,
        disabled: disabled,
        allowClear: true,
        value: value,
        placeholder: placeholder,
        onChange: onchange,
        onBlur: onBlur,
        onKeyPress: onKeyPress,
        suffix: suffix,
        maxLength: maxLength
      });
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, inputRender);
};
CustomInput.defaultProps = {
  dynamicTitleStyle: {
    fontSize: 16,
    color: '#333333'
  },
  headerProps: {
    variant: 'header-text'
  }
};
var _default = exports.default = CustomInput;